import { render } from "./glob-modal.vue?vue&type=template&id=ec3c2f6c&scoped=true"
import script from "./glob-modal.vue?vue&type=script&lang=js"
export * from "./glob-modal.vue?vue&type=script&lang=js"

import "./glob-modal.vue?vue&type=style&index=0&id=ec3c2f6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec3c2f6c"]])

export default __exports__